import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { AppState } from '../../../reducers'
import { getDeparturesAction, openDepartureAction, closeDepartureAction } from '../../../actions/admin/adminTerminals'
import './departures.less'
import { Departure } from '../../../types/departures'
import moment from 'moment-mini'

const defaultText = '?'
const dateFormat = 'DD.MM.YYYY HH:mm'

export type DepartureWithClosedCheckIn = Departure & { closedCheckIn: boolean }

const mapStateToProps = (state: AppState) => ({
  departures: state.adminTerminals.departures,
})

const mapDispatchToProps = {
  getDepartures: getDeparturesAction,
  openDeparture: openDepartureAction,
  closeDeparture: closeDepartureAction,
}
type DispatchProps = typeof mapDispatchToProps
type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps

const Departures: React.FC<Props> = ({ departures, getDepartures, openDeparture, closeDeparture }: Props) => {
  const onClickCloseReOpen = (departure: DepartureWithClosedCheckIn) => {
    if (departure.closedCheckIn) {
      openDeparture(departure)
    } else {
      closeDeparture(departure)
    }
  }

  useEffect(() => {
    getDepartures()
  }, [getDepartures])

  return (
    <div className="admin-departures">
      <div className="table-header row">
        <div className="cell column-port-from">
          <strong>Port From</strong>
        </div>
        <div className="cell column-date-from">
          <strong>Date From</strong>
        </div>
        <div className="cell column-ship">
          <strong>Ship</strong>
        </div>
        <div className="cell column-check-in">
          <strong>Opened departure</strong>
        </div>
        <div className="cell column-close-open-checkbox">
          <strong>Self Check-in opened</strong>
        </div>
        <div className="cell column-close-open-button"></div>
        <div className="space-for-scrollbar"></div>
      </div>
      <div className="table">
        {departures.map((item: DepartureWithClosedCheckIn, index: number) => (
          <div key={index} className={`row ${!item.closedCheckIn ? `closed-departure` : null}`}>
            <div className="cell column-port-from border-right">
              <div className="inner">{(item.portFrom && item.portFrom) || defaultText}</div>
            </div>
            <div className="cell column-date-from border-right">
              <div className="inner">{(item.dateFrom && moment(item.dateFrom).format(dateFormat)) || defaultText}</div>
            </div>
            <div className="cell column-ship border-right">
              <div className="inner">{(item.ship && item.ship) || defaultText}</div>
            </div>
            <div className="cell column-check-in border-right">
              <div className="inner">{item.checkInActivated ? 'yes' : 'no'}</div>
            </div>
            <div className="cell column-close-open-checkbox">
              <div className="inner">{item.closedCheckIn ? 'no' : 'yes'}</div>
            </div>
            <div className="cell column-close-open-button border-right">
              <div className="inner">
                <button className="close-open-button" onClick={() => onClickCloseReOpen(item)}>
                  {item.closedCheckIn ? 'Open' : 'Close'}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Departures)
